<template>
  <v-container class="pt-10 mx-auto"
               style="max-width: 500px">

    <v-form @submit="onSubmit"
            :disabled="isLogging">
      <p class="text-h4">
        Accedi
      </p>
      <v-row>
        <!-- email -->
        <v-col cols="12">
          <v-text-field
            v-model="form.email"
            type="email"
            label="Email"
            @keyup.enter="onSubmit"
            @keyup="$v.form.email.$touch()"
            :error="$v.form.email.$error"
            outlined
          ></v-text-field>
        </v-col>
        <!-- password -->
        <v-col cols="12">
          <v-text-field
            v-model="form.password"
            type="password"
            label="Password"
            @keyup.enter="onSubmit"
            @keyup="$v.form.password.$touch()"
            :error="$v.form.password.$error"
            outlined
          ></v-text-field>
        </v-col>
        <!-- submit -->
        <v-col cols="12"
               class="text-center">
          <v-btn x-large
                 color="primary"
                 @click="onSubmit"
                 :loading="isLogging">
            LOGIN
          </v-btn>
        </v-col>
      </v-row>
    </v-form>

    <v-alert type="error" 
             v-if="error"
             class="mt-10">
      Le credenziali inserite non sono corrette.
    </v-alert>

  </v-container>
</template>

<script>
import API from '@/api'

import { required, email } from 'vuelidate/lib/validators'

import { mapActions, mapGetters, mapMutations } from 'vuex'

import utility from '@/mixins/utility'

import { SSO } from '@zwan-it/zwan-spaces'

export default {
  
  name: 'Login',

  mixins: [ utility ],

  components:
  {

  },

  data: () => ({
    error: false,
    form: {
      email: null,
      password: null
    },
    isLogging: false
  }),
  
  validations: {
    form: {
      email: {
        required,
        email
      },
      password: {
        required
      }
    }
  },

  computed:
  {
    ...mapGetters({
      user: 'auth/user'
    })
  },

  methods: 
  {
    ...mapActions({
      login: 'auth/login'
    }),

    ...mapMutations({
      setLoading: 'ui/setLoading',
      setUserData: 'auth/setUserData'
    }),

    onSubmit()
    {
      this.$v.form.$touch()

      if( this.$v.form.$anyError )
        return false

      this.isLogging = true

      this.error = false

      this.login(this.form)
          .then(()=>this.goTo('home'))
          .catch(()=>this.error=true)
          .finally(()=>this.isLogging=false)
    }, 

    loginSpaces()
    {
      if( this.user )
        return

      const sso = new SSO(),
          token = sso.token

      if( !token )
        return

      this.setLoading()

      this.isLogging = true

      API.auth.deploy(token)
              .then(({ data })=>{
                this.setUserData(data)
              })
              .catch(({ response })=>{
                console.log(response)
              })
              .finally(()=>{
                
                this.setLoading(false)

                this.isLogging = false

              })
    },

  },

  mounted()
  {
    this.loginSpaces()
  },

  watch:
  {
    user(user)
    {
      if(user)
        this.goTo('home')
    }
  }

}
</script>
